<template>
	<div class="settlement-edc-content">
		<SOSlotBase :container-name="'settlement-edc-global'" :bg-grey="true" :is-search="search.onSearch">
			<template v-slot:title-bar>
				<SOTitleBar
					:page-title="'Settlement EDC (Global)'"
					:type="'back'"
					@back="back"
					:show-search="true"
					@search="onOpenSearch"
					v-if="!search.onSearch"
				/>
			</template>
			<template v-slot:search-bar>
				<SOSearchBar
					v-if="search.onSearch"
					:context="'Transaksi'"
					:placeholder="`Ketik minimal 2 karakter`"
					:value="search.key"
					:data-count="countData"
					:search-information="`Nama mesin EDC, Nama outlet, Akun settlement, Id Settlement, Nominal`"
					:waiting="search.searching"
					@do-search="doSearch"
					@loading="onLoadingSearch"
					@close="onCloseSearch"
				/>
			</template>
			<template v-slot:empty-state>
				<div>
					<SOEmptyState
						v-if="countData === 0 && !isFetching && !search.onSearch"
						:message="'Belum Pernah Settlement'"
						:subMessage="'Riwayat settlement dari semua mesin & outlet akan tampil disini.'"
					/>
					<SOEmptySearchState
						v-if="countData === 0 && !isFetching && search.onSearch && search.key.length > 1"
						@action="resetSearchFilter"
					/>
				</div>
			</template>
			<template v-slot:skeleton v-if="isFetching && !isLoadMore">
				<div class="p-x-20 p-y-16 w-limit">
					<CardSkeleton v-if="!search.onSearch"/>
					<SOLoadSearch v-if="search.onSearch"/>
				</div>
			</template>
			<template v-slot:content>
				<div v-if="isNotEmpty && (isMinExport || !isExporting)">
					<SOExportProgressMinimized
						v-if="isMinExport"
						:processed-data="expProgress.processed"
						:total-data="expProgress.total"
						:context="'Settlement EDC'"
						:tracker-actions="`${modulName}/exportTracker`"
						@on-success="checkExport"
						@on-error="exportFail"
					/>
					<SOExportMultipleFile
						v-if="isMultipleExport"
						:export-data="exportData"
						:export-data-length="exportDataLength"
						:delete-cluster-actions="`${modulName}/exportDeleteCluster`"
						:delete-master-actions="`${modulName}/exportDeleteMaster`"
						@done="finishExport"
					/>
				</div>

				<div class="">
					<div class="p-x-20">
						<div class="card_breadcrum p-t-16">
							<SOHeaderList
								v-if="!isFetching"
								:title="isNotEmpty ? `${countData} Settlement` : ''"
								:show-filter="true"
								@filter="togleFilter(true)"
							/>
						</div>
						<div>
							<SOCardSettlementEdcGlobal :search="search"/>
						</div>
					</div>
				</div>

				<SOLoadMoreLoading :id="'load-more-settlement-edc-global'" :loading="isLoadMore"/>
				<div v-if="!isFetching && !isLoadMore && isNotEmpty">
					<SOFABExport @export="openModalExport"/>
				</div>
			</template>
			<template v-slot:filter>
				<SOFilter
					v-if="onFilter"
					:filter-settlement-global="true"
					:sorting="getSorting"
					@back="togleFilter(false)"
					@do-filter="doFilter"
					@reset-filter="resetFilter"
				/>
			</template>
			<template v-slot:export-import>
				<div class="vh-100" v-if="isExporting && !isMinExport">
					<SOExportProgress
						:tracker-actions="`${modulName}/exportTracker`"
						@on-success="checkExport"
						@on-error="exportFail"
						@minimized-export="minimizedExport"
					/>
				</div>
			</template>
		</SOSlotBase>
	</div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import CardSkeleton from "../components/CardSkeleton"
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";

import SOCardSettlementEdcGlobal from "../components/SOCardSettlementEdcGlobal.vue";

import {moduleName} from "../store/state";
import sorting from "../static/sortOrder";

export default {
	name: "SettlementEdcGlobalList",
	components: {
		SOSlotBase,
		SOTitleBar,
		SOHeaderList,
		SOSearchBar,
		SOEmptyState,
		SOEmptySearchState,
		CardSkeleton,
		SOLoadSearch,
		SOLoadMoreLoading,
		SOFABExport,
		SOFilter,
		SOExportProgress,
		SOExportProgressMinimized,
		SOExportMultipleFile,

		SOCardSettlementEdcGlobal,
	},
	computed: {
		...mapGetters(moduleName, {
			response: "response",
			isFetching: "isFetching",
			isLoadMore: "isLoadMore",
			pagination: "pagination",

			displayCard: "displayCard",
			lastItemToView: "lastItemToView",

			listSettlementEdc: "listSettlementEdc",
			countData: "countData",

			expProgress: "exportProgress",
			isExporting: "exporting",
			isMinExport: "minimizedExport",
			isMultipleExport: "multipleExport",
			exportData: "exportData",
			exportDataLength: "exportDataLength",
		}),
		getSorting() {
			return sorting;
		},
		modulName() {
			return moduleName;
		},
		isNotEmpty() {
			return this.$store.getters[`${moduleName}/countData`] > 0;
		},
	},
	data() {
		return {
			search: {
				key: "",
				searching: false,
				onSearch: false,
			},
			onFilter: false,

		};
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (!(from.path.split("/")[1] === "settlement-edc-global" ||
				from.path.split("/")[1] === "mesin-edc")) {
				vm.resetDataList();
				vm.resetPagination();
				vm.resetSearchFilter();
			}
		})
	},
	beforeRouteLeave(to, from, next) {
		if (from.name === "SettlementEdcGlobal") {
			this.setLastItem();
		}
		next();
	},
	mounted() {
		this.init();
		this.scrollTo();

		if (this.$route.query.key !== undefined) {
			if (this.$route.query.key !== "") {
				this.search = {
					key: this.$route.query.key,
					searching: false,
					onSearch: true,
				}
			}
		}
		this.smartTrackingView("settlement_mesin_edc");

	},
	methods: {
		...mapActions({
			getListSettlementEdc: `${moduleName}/getListSettlementEdc`,
			resetPagination: `${moduleName}/resetPagination`,
			setLastItemToView: `${moduleName}/setLastItemToView`,

			toggleExporting: `${moduleName}/toggleExporting`,
			minimized: `${moduleName}/minimizedExport`,
			exportProgress: `${moduleName}/exportProgress`,
			exportTracker: `${moduleName}/exportTracker`,
			multipleExport: `${moduleName}/multipleExport`,
			setExportData: `${moduleName}/setExportData`,
			setExportDataLength: `${moduleName}/setExportDataLength`,
		}),
		async init() {
			if (!this.listSettlementEdc.length) {
				await this.resetFilter()
				await this.getListSettlementEdc(this.search);
			}
		},
		async back() {
			await this.resetDataList();
			await this.resetPagination();
			await this.resetSearchFilter();
			await this.$router.push({name: "dashboard"});
		},

		// scroll
		scrollTo() {
			let el = document.getElementById(this.lastItemToView.id);

			if (el) {
				setTimeout(() => {
					el.scrollIntoView();
					document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
				}, 100);
			}
		},
		setLastItem() {
			let newDP = this.displayCard.sort(function (a, b) {
				if (a.yDir < b.yDir) {
					return -1;
				}
				if (a.yDir > b.yDir) {
					return 1;
				}
				return 0;
			});

			if (newDP[0]) {
				this.setLastItemToView(newDP[0]);
			}
		},

		// search
		async doSearch(searchKey) {
			this.search.key = searchKey;
			await this.onLoadingSearch(false);
			await this.resetPagination();
			await this.resetDataList();
			await this.getListSettlementEdc(this.search);
		},
		onLoadingSearch(value) {
			this.search.searching = value;
		},
		async resetDataList() {
			await this.$store.commit(moduleName + "/resetsetListSettlementEdc")
			await this.$store.commit(moduleName + "/setCountData", 0)
		},
		onOpenSearch() {
			this.toggleSearch(true);
			this.resetPagination();
			this.resetFilter();
			this.resetDataList();
		},
		onCloseSearch() {
			this.search.key = ""
			this.toggleSearch(false);
			this.resetPagination();
			this.resetFilter();
			this.resetDataList();
			this.init();
		},
		toggleSearch(val) {
			this.search.onSearch = val;
		},
		resetSearchFilter() {
			this.resetFilter();
			this.search.key = "";
		},

		// filter
		togleFilter(val) {
			this.onFilter = val;
		},
		async doFilter() {
			await this.resetPagination();
			await this.resetDataList();
			await this.togleFilter(false);
			await this.getListSettlementEdc(this.search);
		},
		async resetFilter() {
			await this.$store.commit("filterGlobalModule/resetFilterItem");
			await this.$store.commit("filterGlobalModule/setFilter", JSON.parse(this.getSorting[0].value));
		},

		// export
		openModalExport() {
			this.$router.push({name: "SettlementEdcGlobal.export", query: {key: this.search.key}});
		},
		async checkExport() {
			this.toggleExporting(false);
			this.minimized(false);
			this.multipleExport(false);

			let tracker = await this.exportTracker();
			if (!tracker.success) {
				return;
			}

			this.setExportDataLength(tracker.data.length);

			if (tracker.data.info_data_export.length > 0) {
				if (tracker.data.status === 1) {
					this.multipleExport(true);
					this.setExportData(tracker.data.info_data_export);
					if (this.exportData.length > 0) {
						this.exportData.forEach((v) => {
							v["downloaded"] = false;
						});
					}
				} else {
					this.minimized(true);
				}
			}
		},
		exportFail() {
			this.toggleExporting(false);
			this.minimized(false);
		},
		minimizedExport(data) {
			this.minimized(true);
			this.exportProgress(data);
		},
		finishExport() {
			this.multipleExport(false);
			this.setExportData([]);
		},
	},
};
</script>
